























































import Vue from 'vue'

import AboutMe from '@/components/AboutMe.vue'
import EmailInfo from '@/components/EmailInfo.vue'
import GitHubInfo from '@/components/GitHubInfo.vue'
import LinkedInInfo from '@/components/LinkedInInfo.vue'
import PersonalInfo from '@/components/PersonalInfo.vue'
import PhoneInfo from '@/components/PhoneInfo.vue'
import TechnicalExperience from '@/components/TechnicalExperience.vue'
import ThemeChanger from '@/components/ThemeChanger.vue'

// lets use composition api here to defineComponent
export default Vue.extend({
  name: 'App',
  components: {
    AboutMe,
    EmailInfo,
    GitHubInfo,
    LinkedInInfo,
    PersonalInfo,
    PhoneInfo,
    TechnicalExperience,
    ThemeChanger
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light'
    }
  }
})
